import wrapRootElement from "@src/wrap-root-element"
import { trackPageView } from "@src/utils/analytics"
import "@static/styles/global.css"

// Fires on the initial load and on every client-side route change. The Meta
// Pixel base snippet (gatsby-ssr.js) only runs fbq('init'), so this is the
// single source of PageView events.
const onRouteUpdate = () => {
  trackPageView()
}

export { wrapRootElement, onRouteUpdate }
